export default (data, schema) => {
    return Object.keys(data).reduce((newData, key) => {
        // Read-only adapter
        if (schema.properties?.[key]?.readOnly) return newData;
        if (data[key] === undefined) newData[key] = null;
        else newData[key] = data[key];
        return newData;
    }, {});
};
